import { Col, Row } from 'react-bootstrap';
import { checkFileFormat, handleErrorMessage } from '../../utils';

import AttachmentTable from '../Reusable/AttachmentTable/AttachmentTable';
import ButtonSave from '../Reusable/ButtonSave';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';
import DatePicker from '../Reusable/KeybordDatePicker';
import { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import InputField from '../Reusable/InputField';
import Modal from 'react-bootstrap/Modal';
import React from 'react';
import UploadFormTable from '../Reusable/UploadFormTable';
import moment from 'moment';
import { uploadFileMaxSize } from '../../constants/globals';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForAddSubmissionDataSignet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uniqueSerialNumber: null,
      beginOfUsage: new Date(),
      plannedStart: new Date(),
      validPeriod: null,
      validUntil: null,
      uploadedImages: [],
      uploadedDocument: [],
      imageForPreview: {},
      destroyedForPreview: {},
      test: {},
      lookForDelete: {},
      destroyedForDelete: {},
      showDestroyedAttachment: false,
      errors: {},
    };
  }

  componentDidMount() {
    const { uniqueSerialNumber, signetStatus, plannedStart, validUntil } =
      this.props.signet;
    const {
      submissionDataSignetDestroyedAttachment,
      submissionDataSignetLookAttachment,
    } = this.props;

    let validPeriodFormat;
    if (plannedStart && validUntil) {
      const plannedStartFormat = moment(plannedStart);
      const validUntilFormat = moment(validUntil);

      validPeriodFormat = moment(validUntilFormat).diff(
        moment(plannedStartFormat),
        'years'
      );
    }

    this.setState({
      uniqueSerialNumber: uniqueSerialNumber,
      plannedStart: plannedStart ? plannedStart : new Date(),
      validUntil: validUntil ? validUntil : null,
      validPeriod: validPeriodFormat ? validPeriodFormat.toString() : null,
      showDestroyedAttachment:
        signetStatus === 'COMPLEMENT_REQUIRED' ||
        signetStatus === 'COMPLEMENTED'
          ? true
          : false,
      lookForPreview: submissionDataSignetLookAttachment,
      destroyedForPreview: submissionDataSignetDestroyedAttachment,
    });
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDateChange = (date, value) => {
    if (!this.state.validPeriod)
      this.setState({ plannedStart: value, validUntil: value });
    else {
      const planStart = moment(value).toDate();
      const valid = moment(planStart).add(
        Number(this.state.validPeriod.id),
        'years'
      );
      this.setState({
        plannedStart: value,
        validUntil: valid,
      });
    }
  };

  handleBeginOfUsageChange = (date, value) => {
    this.setState({ beginOfUsage: value });
  };

  onFileChange = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };

  handleDeleteImage = (documentName) => {
    let uploadedDocumentsNames = [];
    let uploadedDocumentsAsArray = Array.from(this.state.uploadedImages);

    for (let i = 0; i < this.state.uploadedImages.length; i++) {
      uploadedDocumentsNames.push(this.state.uploadedImages[i].name);
    }

    var index = uploadedDocumentsNames.indexOf(documentName);
    uploadedDocumentsAsArray.splice(index, 1);
    this.setState({
      uploadedImages: uploadedDocumentsAsArray,
    });
  };

  handleDeleteDocument = (documentName) => {
    let uploadedDocumentsNames = [];
    let uploadedDocumentsAsArray = Array.from(this.state.uploadedDocument);

    for (let i = 0; i < this.state.uploadedDocument.length; i++) {
      uploadedDocumentsNames.push(this.state.uploadedDocument[i].name);
    }

    var index = uploadedDocumentsNames.indexOf(documentName);
    uploadedDocumentsAsArray.splice(index, 1);
    this.setState({
      uploadedDocument: uploadedDocumentsAsArray,
    });
  };

  handleClientValidation = () => {
    let hasError = false;
    const { Errors } = this.props.t;
    let errors = {};

    if (!this.state.uniqueSerialNumber) {
      errors['uniqueSerialNumber'] = Errors.uniqueSerialNumber;
      hasError = true;
    }

    if (!this.state.plannedStart) {
      errors['plannedStart'] = Errors.plannedStart;
      hasError = true;
    }

    if (!this.state.validUntil) {
      errors['validUntil'] = Errors.validUntil;
      hasError = true;
    }

    if (
      Date.parse(this.state.validUntil) < Date.parse(this.state.plannedStart)
    ) {
      errors['validUntil'] = Errors.invalidValidUntil;
      hasError = true;
    }

    if (!this.state.beginOfUsage) {
      errors['beginOfUsage'] = Errors.beginOfUsage;
      hasError = true;
    }

    if (this.state.uploadedImages) {
      if (checkFileFormat(this.state.uploadedImages)) {
        errors['uploadedImages'] = Errors.invalidFormat;
        hasError = true;
      }
    }

    if (
      this.state.lookForPreview &&
      Object.keys(this.state.lookForPreview).length !== 0
    ) {
      if (
        this.state.uploadedImages.length === 0 &&
        Object.keys(this.state.lookForDelete).length !== 0
      ) {
        errors['uploadedImages'] = Errors.imageNotUploaded;
        hasError = true;
      }
    } else {
      if (this.state.uploadedImages.length === 0) {
        errors['uploadedImages'] = Errors.imageNotUploaded;
        hasError = true;
      }
    }

    if (this.state.uploadedImages.length > 0) {
      let uploadedDataSize = 0;
      for (let i = 0; i < this.state.uploadedImages.length; i++) {
        uploadedDataSize += this.state.uploadedImages[i].size;
      }
      if (uploadedDataSize >= uploadFileMaxSize) {
        errors['uploadedImages'] = Errors.invalidFileSize;
        hasError = true;
      }
    }

    if (this.state.showDestroyedAttachment) {
      if (this.state.uploadedDocument) {
        if (checkFileFormat(this.state.uploadedDocument)) {
          errors['uploadedDocument'] = Errors.invalidFormat;
          hasError = true;
        }
      }

      if (this.state.uploadedDocument.length > 0) {
        let uploadedDataSize = 0;
        for (let i = 0; i < this.state.uploadedDocument.length; i++) {
          uploadedDataSize += this.state.uploadedDocument[i].size;
        }
        if (uploadedDataSize >= uploadFileMaxSize) {
          errors['uploadedDocument'] = Errors.invalidFileSize;
          hasError = true;
        }
      }
    }

    this.setState({ errors });

    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.handleClientValidation()) {
      return;
    }

    const newSubmissionDataSignet = {
      signet: {
        ...this.props.signet,
        uniqueSerialNumber: this.state.uniqueSerialNumber,
        plannedStart: this.state.plannedStart,
        validUntil: this.state.validUntil,
        beginOfUsage: this.state.beginOfUsage,
      },
    };

    let formData = new FormData();
    if (this.state.uploadedImages.length > 0) {
      formData.append('image', this.state.uploadedImages[0]);
      formData.append('name', this.state.uploadedImages[0].name);
    } else {
      formData.append('image', null);
    }

    formData.append(
      'submissionDataSignet',
      new Blob([JSON.stringify(newSubmissionDataSignet)], {
        type: 'application/json',
      })
    );

    if (this.state.uploadedDocument.length === 0) {
      formData.append(
        'destroyedForDelete',
        new Blob([JSON.stringify(this.state.destroyedForDelete)], {
          type: 'application/json',
        })
      );
      this.props.handleAddWithLook(formData, this.props.signet.signetStatus);
    } else {
      formData.append('destroyedDocument', this.state.uploadedDocument[0]);

      this.props.handleAdd(formData);
    }
  };

  changeComboAutocompleteValue = (name, newValue) => {
    const planStart = moment(this.state.plannedStart).toDate();
    const valid = moment(planStart).add(Number(newValue), 'years');
    this.setState({
      validPeriod: newValue,
      validUntil: valid,
    });
  };

  handleDeleteImageUploaded = (attachment) => {
    let uploadedDocumentsNames = [];

    for (let i = 0; i < [this.state.lookForPreview].length; i++) {
      uploadedDocumentsNames.push(
        this.state.lookForPreview.embeddableAttribute.name
      );
    }

    this.setState({
      lookForPreview: {},
      lookForDelete: attachment,
    });
  };

  handleDeleteDestroyedUploaded = (attachment) => {
    let uploadedDocumentsNames = [];

    for (let i = 0; i < [this.state.destroyedForPreview].length; i++) {
      uploadedDocumentsNames.push(
        this.state.destroyedForPreview.embeddableAttribute.name
      );
    }

    this.setState({
      destroyedForPreview: null,
      destroyedForDelete: attachment,
    });
  };

  render() {
    const { error, t } = this.props || {},
      { Labels } = t || {};

    const validPeriods = ['1', '2', '3', '4', '5'];

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{Labels.title}</h5>
            <form noValidate onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <Row>
                    <Col md={6}>
                      <InputField
                        name="uniqueSerialNumber"
                        placeholder={t.Placeholders.uniqueSerialNumber}
                        multiple={false}
                        required
                        onChange={this.onChange}
                        value={this.state.uniqueSerialNumber}
                        error={handleErrorMessage(
                          error,
                          'uniqueSerialNumber',
                          this.state.errors.uniqueSerialNumber
                        )}
                      />
                    </Col>
                    <Col md={6}>
                      <DatePicker
                        label={t.Placeholders.beginOfUsage}
                        handleDateChange={this.handleBeginOfUsageChange}
                        name="beginOfUsage"
                        value={this.state.beginOfUsage}
                        error={handleErrorMessage(
                          error,
                          'beginOfUsage',
                          this.state.errors.beginOfUsage
                        )}
                        minDate={new Date()}
                      />
                    </Col>
                  </Row>
                  <Grid
                    container
                    style={{ display: 'flex' }}
                    className="m-auto"
                    spacing={2}
                  >
                    <Grid item xs={12} md={4} className="mr-auto">
                      <DatePicker
                        label={t.Placeholders.plannedStart}
                        handleDateChange={this.handleDateChange}
                        name="plannedStart"
                        value={this.state.plannedStart}
                        error={handleErrorMessage(
                          error,
                          'plannedStart',
                          this.state.errors.plannedStart
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} className="mr-auto mt-4">
                      <ComboBoxAutocomplete
                        data={validPeriods}
                        text={(period) => period}
                        changeValue={(newValue) =>
                          this.changeComboAutocompleteValue(
                            'validPeriod',
                            newValue
                          )
                        }
                        wholeObject
                        placeholder={t.Placeholders.validPeriod}
                        updateValue={this.state.validPeriod}
                      />
                      <label>
                        <em>
                          <span>* </span>
                          {t.Placeholders.validPeriodInfo}
                        </em>
                      </label>
                    </Grid>
                    <Grid item xs={12} md={4} className="ml-auto">
                      <DatePicker
                        label={t.Placeholders.validUntil}
                        handleDateChange={this.handleDateChange}
                        name="validUntil"
                        value={this.state.validUntil}
                        error={handleErrorMessage(
                          error,
                          'validUntil',
                          this.state.errors.validUntil
                        )}
                        disabled
                      />
                    </Grid>
                  </Grid>
                  {this.state.lookForPreview &&
                    Object.keys(this.state.lookForPreview).length !== 0 && (
                      <Fragment>
                        <h5>{Labels.titleLook}</h5>
                        <AttachmentTable
                          attachments={[this.state.lookForPreview]}
                          controllerReference={'submissionDataSignetLook'}
                          handleDeleteDocument={this.handleDeleteImageUploaded}
                          signal={true}
                        />
                      </Fragment>
                    )}
                  {this.state.lookForPreview &&
                    Object.keys(this.state.lookForPreview).length === 0 && (
                      <UploadFormTable
                        name="uploadedImages"
                        onChange={this.onFileChange}
                        handleDeleteDocument={this.handleDeleteImage}
                        uploadedFiles={this.state.uploadedImages}
                        placeholder={t.Placeholders.uploadSignetLook}
                        errors={handleErrorMessage(
                          error,
                          'uploadedImages',
                          this.state.errors.uploadedImages
                        )}
                      />
                    )}
                  {this.state.showDestroyedAttachment && (
                    <div>
                      {this.state.destroyedForPreview && (
                        <Fragment>
                          <h5>{Labels.titleDestroyed}</h5>
                          <AttachmentTable
                            attachments={[this.state.destroyedForPreview]}
                            controllerReference={
                              'submissionDataSignetDestroyed'
                            }
                            handleDeleteDocument={
                              this.handleDeleteDestroyedUploaded
                            }
                            signal={true}
                          />
                        </Fragment>
                      )}
                      {!this.state.destroyedForPreview && (
                        <UploadFormTable
                          name="uploadedDocument"
                          onChange={this.onFileChange}
                          handleDeleteDocument={this.handleDeleteDocument}
                          uploadedFiles={this.state.uploadedDocument}
                          placeholder={t.Placeholders.uploadSignetDestroyed}
                          errors={handleErrorMessage(
                            error,
                            'uploadedDocument',
                            this.state.errors.uploadedDocument
                          )}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddSubmissionDataSignet,
  'ModalForAddSubmissionDataSignet'
);
